<div class="email-preview-page">
  <div class="preview-container">
    <app-email-preview *ngIf="emailData" [emailData]="emailData" [showViewInBrowser]="false"></app-email-preview>
  </div>
</div>

